import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../updateAction";
import KenAll from "ken-all";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../assets/images/Header.png";
import Step1 from "../assets/images/stepbar_1.png";
import Icon1 from "../assets/images/product-4l.png";
import Icon2 from "../assets/images/product-4x300.png";

const FormInput = (props) => {
  const { actions, state } = useStateMachine({ updateAction });
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: { quantity1: 0, quantity2: 0 },
  });

  const couponList = [
    { code: "KCTEVN3R", price: 0.9 },
    { code: "", price: 1 },
  ];

  const [errorProduct, setErrorProduct] = useState(true);
  const [errorMax, setErrorMax] = useState(false);

  const [CouponCode, setCouponCode] = useState(false);
  const [coupon, setCoupon] = useState("");

  const [discount, setDiscount] = useState(0);
  const [price, setPrice] = useState({
    subtotal: 0,
    shipping: 0,
    couponAmount: 1,
  });
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setTotal(() => price.subtotal * price.couponAmount);
    setDiscount(() =>
      price.couponAmount !== 0
        ? Math.ceil(price.subtotal * (1 - price.couponAmount))
        : 0
    );
  }, [price]);

  const onChangeZipcode = (e) => {
    const inputValue = e.currentTarget.value;
    if (inputValue.length >= 7) {
      const checkValue = inputValue.toLowerCase().replace(/-/g, "");
      if (checkValue.length === 7) {
        KenAll(checkValue).then((res) => {
          if (res.length === 0) {
          } else {
            setValue("deliveryPref", res[0][0]);
            setValue("deliveryAddress1", res[0][1] + res[0][2]);
          }
        });
      }
    }
  };

  const onChangeCoupon = (e) => {
    setCoupon(e.target.value);
    e.target.value ? setCouponCode(true) : setCouponCode(false);
  };
  const onChangeCouponSearch = (e) => {
    const getCoupon = couponList.filter((c) => {
      return c.code === coupon;
    });
    const totalNumber =
      parseInt(getValues("quantity1")) + parseInt(getValues("quantity2"));
    if (getCoupon.length !== 0) {
      if (totalNumber > 1) {
        setPrice({ ...price, couponAmount: getCoupon[0].price });
      }
    } else {
      setPrice({ ...price, couponAmount: 1 });
    }
  };

  const onChangeQuantity = (e) => {
    const totalNumber =
      parseInt(getValues("quantity1")) + parseInt(getValues("quantity2"));
    switch (e.target.name) {
      case "quantity1":
        clearErrors("quantity1");
        clearErrors("quantity2");
        setPrice({
          ...price,
          subtotal:
            0 + getValues("quantity1") * 6600 + getValues("quantity2") * 7150,
          shipping: e.target.value * 0,
        });
        if (totalNumber < 1) {
          setError("quantity2", {
            types: {
              required: "数量を指定ください",
            },
          });
          setErrorProduct(true);
        } else {
          setErrorProduct(false);
          if (totalNumber >= 21) {
            setErrorMax(true);
          } else {
            setErrorMax(false);
          }
        }
        break;
      case "quantity2":
        clearErrors("quantity1");
        clearErrors("quantity2");
        setPrice({
          ...price,
          subtotal:
            0 + getValues("quantity2") * 7150 + getValues("quantity1") * 6600,
          shipping: e.target.value * 0,
        });
        if (totalNumber < 1) {
          setError("quantity1", {
            types: {
              required: "数量を指定ください",
            },
          });
          setErrorProduct(true);
        } else {
          setErrorProduct(false);
          if (totalNumber >= 21) {
            setErrorMax(true);
          } else {
            setErrorMax(false);
          }
        }
        break;
      default:
    }
  };

  const onSubmit = (data) => {
    if (parseInt(data.quantity1) + parseInt(data.quantity2) < 1) {
      setError("quantity1", {
        types: {
          required: "必須項目です",
        },
      });
      setError("quantity2", {
        types: {
          required: "必須項目です",
        },
      });
    } else {
      const formData = {
        ...data,
        subtotal: price.subtotal,
        shipping: price.shipping,
        discount: discount,
        total: total,
        coupon: coupon,
      };
      actions.updateAction(formData);
      props.history.push("./entry/confirm");
    }
  };

  return (
    <>
      <div className="layout">
        <div className="layout__content">
          <img src={Header} alt="" />
          <div className="container">
            <div className="row" style={{ alignItems: "flex-start" }}>
              <img src={Step1} alt="" className="stepbar" />
            </div>
          </div>
          <div className="container">
            <div className="row"></div>
          </div>
          <section className="con-lead">
            <div className="container">
              <div className="row">
                <div className="col_12 con_form">
                  <div className="col_12 con_form_note">
                    <p className="con_lead__txt">
                      ・本フォームでは法人のお客様のみご注文が可能です。
                      <br />
                      ・見積り書が必要な方は
                      <a
                        href="https://www.tactinc.jp/contact"
                        target="_blank"
                        rel="noreferrer noopener"
                        style={{ textDecoration: "none" }}
                      >
                        お問合せ
                      </a>
                      よりご希望の商品、点数をご連絡ください。
                      <br />
                      ・「✳︎」の付いている項目は必ずご記入ください。
                    </p>
                  </div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="title-header">
                      <p>ご注文商品情報入力</p>
                    </div>
                    <div className="col_12">
                      <ul className="con_product_items table_ul">
                        <li className="con_product_box">
                          <img src={Icon1} alt=""></img>
                        </li>
                        <li className="con_product_box con_product_text">
                          <span>ハンドクリーン71 4L</span>
                          <span>6,600円（税込）</span>
                        </li>
                        <li className="con_product_box">
                          <input
                            className="con_form__input_min"
                            name="quantity1"
                            ref={register}
                            type="number"
                            min="0"
                            placeholder="0"
                            defaultValue={parseInt(state.quantity1) || ""}
                            onChange={onChangeQuantity}
                          />
                          <span className="count_text">セット</span>
                          {errors.quantity1 && (
                            <p className="formError error_text">必須項目です</p>
                          )}
                        </li>
                      </ul>
                      <ul className="con_product_items table_ul">
                        <li className="con_product_box">
                          <img src={Icon2} alt=""></img>
                        </li>
                        <li className="con_product_box con_product_text">
                          <span>ハンドクリーン71 4L×300mL 1セット</span>
                          <span>7,150円（税込）</span>
                        </li>
                        <li className="con_product_box">
                          <input
                            className="con_form__input_min"
                            name="quantity2"
                            ref={register}
                            type="number"
                            min="0"
                            placeholder="0"
                            defaultValue={parseInt(state.quantity2) || ""}
                            onChange={onChangeQuantity}
                          />
                          <span className="count_text">セット</span>
                          {errors.quantity2 && (
                            <p className="formError error_text">必須項目です</p>
                          )}
                          {errorProduct && (
                            <p className="formError error_text">
                              注文数をご入力下さい
                            </p>
                          )}
                        </li>
                      </ul>

                      <ul className="con_product_items table_ul">
                        <li className="con_product_box con_product_text">
                          {errorMax && (
                            <p
                              className="formError error_text"
                              style={{ color: "#878787" }}
                            >
                              1拠点で
                              80L以上の貯蔵、取り扱いをご検討の方は、消防法をご確認の上ご注文下さい。
                            </p>
                          )}
                        </li>
                      </ul>

                      <ul className="con_product_items table_ul">
                        <div className="con_form_li">
                          <label className="con_form__label">
                            クーポンコード
                          </label>
                          <div className="con_form__input_box">
                            <input
                              className="con_form__input"
                              name="couponCode"
                              placeholder="クーポンをお持ちの場合入力ください"
                              value={coupon}
                              onBlur={onChangeCouponSearch}
                              onChange={onChangeCoupon}
                            />
                          </div>
                        </div>
                      </ul>
                      <div className="con_product_items__sum">
                        <div className="">
                          <ul className="con_form_ul__sum">
                            <li>
                              <p className="con_product_text__text">商品小計</p>
                              <p className="con_product_text__num">
                                ¥ {price.subtotal.toLocaleString()}
                              </p>
                            </li>
                          </ul>
                          <ul className="con_form_ul__sum">
                            <li>
                              <p className="con_product_text__text">送料</p>
                              <p className="con_product_text__num">
                                ¥ {price.shipping.toLocaleString()}
                              </p>
                            </li>
                          </ul>
                          {CouponCode && (
                            <ul className="con_form_ul__sum">
                              <li>
                                <p className="con_product_text__text">
                                  クーポン値引き
                                </p>
                                <p className="con_product_text__num">
                                  ¥ {discount.toLocaleString()}
                                </p>
                              </li>
                            </ul>
                          )}
                          <ul className="con_form_ul__sum">
                            <li>
                              <p className="con_product_text__text">合計</p>
                              <p className="con_product_text__num">
                                ¥ {total.toLocaleString()}
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="title-header">
                      <p>購入者情報入力</p>
                    </div>
                    <div className="col_12 con_form_box">
                      <div className="con_form_li">
                        <label className="con_form__label">
                          会社名/屋号
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="company"
                            placeholder="株式会社TACT"
                            ref={register({ required: true })}
                            defaultValue={state.company || ""}
                          />
                          {errors.company && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          代表者氏名
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="companyPersonalName"
                            placeholder="山田太郎"
                            ref={register({ required: true })}
                            defaultValue={state.companyPersonalName || ""}
                          />
                          {errors.companyPersonalName && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          URL
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="url"
                            type="url"
                            placeholder="https://tactinc.jp"
                            ref={register({
                              required: true,
                            })}
                            defaultValue={state.url || ""}
                          />
                          {errors.url && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          担当者氏名
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="personalName"
                            placeholder="除菌花子"
                            ref={register({ required: true })}
                            defaultValue={state.personalName || ""}
                          />
                          {errors.personalName && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          配送先名
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="deliveryName"
                            placeholder="株式会社TACT"
                            defaultValue={state.deliveryName || ""}
                            ref={register({ required: true })}
                          />
                          {errors.deliveryName && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          配送先郵便番号
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="deliveryZipcode"
                            placeholder="1500001"
                            ref={register({ required: true })}
                            defaultValue={state.deliveryZipcode || ""}
                            onChange={onChangeZipcode}
                          />
                          {errors.deliveryZipcode && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li__non">
                        <label className="con_form__label">
                          <div style={{ display: "block", width: 300 }}>
                            配送先住所
                            <br />
                            <span style={{ fontSize: 1 }}>
                              ※ 配送先が複数ある場合は配送先ごとにご注文下さい。
                            </span>
                          </div>
                        </label>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          都道府県
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="deliveryPref"
                            placeholder="東京都"
                            ref={register({ required: true })}
                            defaultValue={state.deliveryPref || ""}
                          />
                          {errors.deliveryPref && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          市区町村・番地
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="deliveryAddress1"
                            placeholder="渋谷区神宮前1-3-10"
                            ref={register({ required: true })}
                            defaultValue={state.deliveryAddress1 || ""}
                          />
                          {errors.deliveryAddress1 && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          建物名・部屋番号
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="deliveryAddress2"
                            placeholder="田村駒ビル 5F"
                            ref={register}
                            defaultValue={state.deliveryAddress2 || ""}
                          />
                          {errors.deliveryAddress2 && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          配送希望日
                          <span className="requiredIcon">*</span>
                          <span style={{ fontSize: 1, display: "block" }}>
                            ※ 通常4営業日以内での発送となります。
                          </span>
                        </label>
                        <div className="con_form__input_box">
                          <select
                            className="con_form__input"
                            name="date"
                            ref={register({ required: true })}
                            defaultValue={state.date || ""}
                          >
                            <option value="">下記よりご選択ください</option>
                            <option value="最短（土日祝を含む）での発送">
                              最短（土日祝を含む）での発送
                            </option>
                            <option value="平日での発送">平日での発送</option>
                          </select>
                          {errors.date && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          電話番号
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="tel"
                            type="tel"
                            placeholder="03-6741-4152"
                            ref={register({
                              required: true,
                            })}
                            defaultValue={state.tel || ""}
                          />
                          {errors.tel && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          メールアドレス
                          <span className="requiredIcon">*</span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="mail"
                            type="email"
                            placeholder="test@tactinc.jp"
                            ref={register({
                              required: true,
                            })}
                            defaultValue={state.mail || ""}
                          />
                          {errors.mail && (
                            <span className="formError error_text">
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <label className="con_form__label">
                          請求書送付先メールアドレス
                          <span className="requiredIcon">*</span>
                          <span style={{ fontSize: 1, display: "block" }}>
                            ※ お支払い方法は請求書払いのみとなります。
                          </span>
                        </label>
                        <div className="con_form__input_box">
                          <input
                            className="con_form__input"
                            name="mailInvoice"
                            type="email"
                            placeholder="keiri@tactinc.jp"
                            ref={register({
                              required: true,
                            })}
                            defaultValue={state.mailInvoice || ""}
                          />
                          {errors.mailInvoice && (
                            <span
                              style={{ display: "block" }}
                              className="formError error_text"
                            >
                              必須項目です
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="con_form_li">
                        <div className="con_form_li__terms">
                          <div className="con_form_terms">
                            <label className="con_form_terms__label">
                              規約
                            </label>
                          </div>
                          <div
                            className="con_form_terms"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="con_form_terms_box"
                              style={{ border: "1px solid #a3a3a3" }}
                            >
                              <p>
                                物品売買契約約款
                                <br />
                                <br />
                                第1条（本約款の目的）
                                <br />
                                この物品売買契約約款（以下「本約款」といいます。）は、株式会社ＴＡＣＴ（以下「売主」といいます。）が取扱う「ハンドクリーン71」(以下「本物品」といいます。)の売買の基本的な条件について定めることを目的とします。
                                <br />
                                <br />
                                第2条（本約款の適用）
                                <br />
                                １．本約款は、売主が本物品を売り渡し、お客様（以下、「買主」といいます。）がこれを買い受ける個別の売買契約（以下、「本契約」といいます。）に対して、適用されます。ただし、売主と買主との間で別段の定めをした場合には、その定めが優先されるものとします。
                                <br />
                                ２．本物品の詳細及び仕様は、売主のウェブサイト等に記載するものとし、当該記載内容は本契約の一部を構成するものとします。
                                <br />
                                ３．本物品の使用は、売主のウェブサイト・パッケージ等に掲載された注意事項等（以下総称して、「注意事項等」といいます。）を遵守して、買主の費用と責任で行うものとします。
                                <br />
                                <br />
                                第３条（申込みの方法）
                                <br />
                                買主は、売主が定める方法により、本約款の内容に同意の上、本契約の申込みを行うものとします。
                                <br />
                                <br />
                                第４条（本契約の成立）
                                <br />
                                １．本契約は、売主が定める方法によって申込みを承諾したときに成立するものとします。
                                <br />
                                ２．前項の規定にかかわらず、売主は、買主について、次の各号に掲げる事由のいずれかに該当すると判断する場合には、当該申込みを承諾しないこと、又はその承諾を留保することがあります。
                                <br />
                                (１)本約款に違反するおそれがあるとき。
                                <br />
                                (２)売り主に対して負担する債務の履行について現に遅滞が生じているとき、又は過去において遅滞の生じたことがあるとき。
                                <br />
                                (３)第１７条に定める反社会的勢力に該当するとき、又はそのおそれがあるとき。
                                <br />
                                (４)前各号に定める場合のほか、本契約に基づく義務を遂行する上で支障があるとき、又は支障の生じるおそれがあるとき。
                                <br />
                                ３．前項に定めるところに従って、売主が本契約の申込みを承諾せず、又は承諾を留保する場合には、その旨を買主に通知します。売主は、承諾をしなかったこと、又は承諾を留保したことによる責任を負いません。
                                <br />
                                <br />
                                第５条（納入日）
                                <br />
                                １．売主は、買主に対し、本契約に定めた納入日に納入場所で本物品を納入します。納入に要する費用（運送費用、梱包費用等を含みます。）は、売主の負担とします。売主及び買主は、自己の費用により本契約に定めた納入日及び納入場所を変更するときは、相手方の同意を得なければなりません。
                                <br />
                                ２．売主は、納入日に本物品の全部又は一部を納入することができない事由が発生した場合、又はそのおそれがある場合、遅滞なくその理由及び納入予定日を買主に通知し、買主と協議するものとします。
                                <br />
                                ３．買主は、納入の遅滞が、天災、売主の本物品発注先若しくは買付け先における倒産又は納入遅延その他売主の責に帰すべからざる事由によるときは、納入日について相当の日数の延長を認め、売主の当該遅延に係る責任を免責するものとします。
                                <br />
                                <br />
                                第６条（納入、検査、引渡し）
                                <br />
                                １．買主は、本物品の納入を受けた後、１４日以内（以下、「検査期間」といいます。）に本物品を検査し、売り主に対して合格又は不合格の通知を行うものとします。
                                <br />
                                ２．検査の結果が不合格の場合、買主は、直ちに理由を記載した書面をもって売主に不合格の通知をしなければなりません。この場合、売主は、買主と協議の上、遅滞なく不足品又は代品を納入します。
                                <br />
                                ３．前項に定める通知がなされないまま第１項に定める検査期間が経過したときは、本物品は検査に合格したものとみなします。
                                <br />
                                ４．本物品は、買主が売主に検査の合格を通知した時、又は前項により検査に合格したものとみなされた時に、売主に買主に対する引渡しがなされたものとします。
                                <br />
                                ５．納入前に生じた本物品の滅失、毀損、減量、変質、その他一切の損害は、買主の責に帰すべきものを除き売主が負担し、本物品の納入以降に生じたこれらの損害は、売主の責に帰すべきものを覗き買主が負担するものとします。
                                <br />
                                <br />
                                第７条（所有権）
                                <br />
                                本物品の所有権は、本物品の売買代金その他本契約に基づく一切の債務を支払った時（ただし、当該売買代金を定めない場合は、本物品の引渡日）に、売主から買主に移転します。なお、買主は、本物品の所有権の買主への移転の移管にかかわらず、本物品を再販売することができるものとします。
                                <br />
                                <br />
                                第８条（売買代金等）
                                <br />
                                買主は、売主に対し、納入日の属する月の翌月末日までに、本物品の売買代金を売主の予め指定する銀行口座に振り込む方法により支払うものとします。支払いの際にひるような銀行振込手数料については、買主の負担とします。
                                <br />
                                <br />
                                第９条（保証等）
                                <br />
                                本物品の品質等が本契約の内容に適合していない場合でも、買主は、売主に対して、本物品の不足品及び代品の引渡、代金減額及び損害賠償を請求できないものとし、かつ、本契約の全部又は一部を解除できないものとします。
                                <br />
                                <br />
                                第１０条（製造物責任）
                                <br />
                                １．売主及び買主は、本物品の欠陥(製造物責任法第２条で規定する定義をいいます。以下同じ。)若しくはそのおそれがあることを知った場合、又は、本物品の欠陥に起因して第三者から苦情、損害賠償請求等の請求を受けた場合は、直ちに相手方に通知し、協議の上原因の分析、損害拡大の防止措置等を行うものとします。
                                <br />
                                ２．売主は、本物品の欠陥に起因して事故が発生した場合、自己の責任と費用において当該事故を処理、解決し、買主が損害を被ったときは、買主に対してその損害を賠償します。ただし、買主の責に帰すべき事由がある場合には、この限りでありません。
                                <br />
                                <br />
                                第１１条（秘密保持）
                                <br />
                                １．売主及び買主は、本契約に関し相手方から開示された情報(以下、「秘密情報」といいます。)を善良な管理者の注意をもって管理し、事前の相手方の書面による同意が無い限り、他に漏洩し、又は公開してはならないものとします。ただし、法令、政府機関、裁判所の命令又は証券取引所の定める規則（以下、「命令等」といいます。）により開示を義務付けられる場合は、この限りではありません。この場合において、命令等により秘密情報を開示した当事者は、相手方にその旨通知するものとします。なお、本条において、情報を開示された当事者を「受領当事者」といいます。
                                <br />
                                ２．次の各号に該当する情報については、秘密情報に該当しないものとします。
                                <br />
                                (１)開示された時点で、既に公知となっている情報
                                <br />
                                (２)開示された時点で、既に受領当事者が保有していた情報
                                <br />
                                (３)開示された後、受領当事者の責によらずに公知となった情報
                                <br />
                                (４)開示された後、受領当事者が第三者から守秘義務を負うことなく適法に取得した情報
                                <br />
                                (５)開示された情報とは関係なく独自に開発又は発見した情報
                                <br />
                                ３．受領当事者は、秘密情報を本契約の目的以外の目的に使用してはならず、本契約の目的に必要な限度を超えて、秘密情報を複製してはならないものとします。
                                <br />
                                ４．本条に基づく義務は、本契約終了後も３年間有効に存続するものとします。
                                <br />
                                <br />
                                第１２条（損害賠償責任）
                                <br />
                                １．売主が買主に対して本契約に関連して負担する損害賠償責任の範囲は、その原因の如何にかかわらず、買主が直接かつ現実に被った通常の損害に限るものとし、
                                買主におけるビジネス機会の喪失、信用の毀損の結果生じた損害又は逸失利益については、何ら責任を負わないものとします。
                                <br />
                                ２．前項により売主が損害賠償責任を負う場合であっても、損害賠償の総額は、買主が売主に対して支払った本契約に定める売買代金相当額を上限とします。
                                <br />
                                <br />
                                第１３条（不可抗力）
                                <br />
                                本契約における義務の遂行が、天災地変、火災、感染症の流行、偶発事故、合理的な輸送手段の利用不能、法令・行政指導その他売主の責に帰すべからざる事由により不能（一部不能を含みます。）
                                又は履行遅滞となった場合に生じた損害について、売主は、賠償責任その他の責任を負わないものとします。
                                <br />
                                <br />
                                第１４条（解除）
                                <br />
                                １．売主又は買主は、相手方が以下の各号のいずれかに該当した場合は、催告及び自己の債務の履行の提供をしないで直ちに本契約の全部又は一部を解除することができるものとします。
                                <br />
                                (１)本約款に違反したとき。
                                <br />
                                (２)
                                監督官庁から営業停止、営業免許若しくは営業登録の取消等の処分を受けたとき。
                                <br />
                                (３)
                                差押、仮差押、仮処分、強制執行、担保権の実行としての競売、租税滞納処分その他これらに準じる手続が開始されたとき。
                                <br />
                                (４)
                                破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始等の申立てがなされたとき、又はそれらの手続開始等の要件に該当する事由があると認められたとき。
                                <br />
                                (５)
                                自ら振り出し若しくは引き受けた手形又は小切手が不渡りとなる等支払停止状態に至ったとき。
                                <br />
                                (６)
                                解散若しくは事業の全部を譲渡し、又はその決議がなされたとき。
                                <br />
                                (７)
                                民法第542条第1項各号に掲げる場合又は同条第２項各号に該当するとき。
                                <br />
                                (８)
                                前各号に掲げるほか、支払能力の不安、背信的行為の存在等、本契約を継続することが著しく困難な事情が生じたとき。
                                <br />
                                ２．売主又は買主が前項各号の一に該当した場合、金銭債務につき当然に期限の利益を喪失し、何らの催告なく相手方に対し一切の債務を直ちに履行しなければなりません。
                                <br />
                                ３．売主又は買主が第1項各号の一に該当したことによって相手方が損害を被ったときは、当該相手方は、同項に基づき契約を解除したか否かを問わず、その損害の賠償を請求することができます。
                                <br />
                                ４．買主が、第1項各号の一に該当し、又は本物品に関し苦情を申し立て、若しくは理由の如何を問わず本物品の売買代金を期限に支払わないおそれがあるときは、
                                売主は、売主買主間のすべての個別契約に基づく本物品の全部又は一部の納入を停止し、または中止することができる。
                                <br />
                                <br />
                                第１５条（本物品の輸出）
                                <br />
                                １．買主は、本物品を日本国内で使用するものとします。
                                <br />
                                ２．本物品を輸出する場合、買主は、自らの費用と責任で、輸出者として日本国及び輸出関連諸国の輸出関連法規に従って輸出を行うものとします。
                                買主が、本物品を日本国内で第三者に販売するときは、当該第三者にもその旨通知のうえ、義務付けるものとします。
                                <br />
                                ３．買主が、前項により本物品を輸出する場合、第9条（保証等）及び第10条（製造物責任）は適用されないものとします。
                                <br />
                                <br />
                                第１６条（知的財産権）
                                <br />
                                本物品に関する特許権、実用新案権、意匠権、著作権（著作権法第27条及び第28条に定める権利を含みます。）、商標権その他の知的財産権は、売主又は売主の本物品発注先若しくは買付け先に帰属します。
                                買主は、本物品に関する知的財産権を侵害し、又は侵害することを企図してはならず、本物品を第三者に販売するときは、当該第三者にもその旨通知のうえ、義務付けるものとします。
                                <br />
                                <br />
                                第１７条（反社会的勢力の排除）
                                <br />
                                １．売主及び買主は、現在及び将来にわたって、自己又は自己の役職員が暴力団、暴力団の構成員、暴力団関係企業、その他の反社会的勢力でないことを表明し、保証するものとします。
                                <br />
                                ２．売主及び買主は、暴力的又は脅迫的な要求行為、法的な責任を超えた不当な要求行為、その他これらに準ずる行為を行わず、又は第三者をして行わせしめないことを表明し、保証するものとします。
                                <br />
                                ３．売主及び買主は、相手方が前二項に定める表明保証に反した場合は、将来に向かって直ちに本契約を解除できるものとします。
                                <br />
                                ４．売主及び買主は、本条に基づく解除により相手方が被った損害について、一切の義務及び責任を負わないものとします。
                                <br />
                                <br />
                                第１８条（本規約の変更）
                                <br />
                                １．売主は、買主の利益に適合する場合、又は変更が本約款の目的に反せず、変更の必要性、変更後の内容の相当性がある場合、本約款を随時変更することができます。
                                <br />
                                ２．売主は、本約款を変更する場合、本約款の変更条件及び適用開始日を売主のウェブサイトへの掲載その他の適切な方法により事前に周知するものとします。
                                <br />
                                <br />
                                第１９条（協議）
                                <br />
                                １．本約款の解約について両当事者に異議、疑義が生じた場合、又は本約款に定めのない事項が生じた場合、誠実に協議し、円満にその解決を図るものとします。
                                <br />
                                ２．前項の協議を行う場合であって、相手方の求めがあるときは、売主及び買主は、当該協議を行う旨の合意を書面又は電磁的記録にて行うものとします。
                                <br />
                                <br />
                                第２０条（準拠法・裁判管轄）
                                <br />
                                １．本約款の準拠法は日本法とします。
                                <br />
                                ２．本約款に起因又は関連する紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
                                <br />
                                <br />
                                以上
                                <br />
                                <br />
                                制定 ２０２１年０３月０１日
                                <br />
                                <br />
                              </p>
                            </div>
                          </div>
                          <div>
                            <p>
                              ※当社の
                              <a
                                href="https://www.tactinc.jp/document/agreement"
                                target="_blank"
                                rel="noreferrer noopener"
                                style={{
                                  // textDecoration: "none",
                                  color: "initial",
                                }}
                              >
                                個人情報の取扱いに関する同意事項
                              </a>
                              に同意の上、注文内容の確認にお進みください
                            </p>
                          </div>

                          <div className="con_form_terms">
                            <div className="checkbox_input">
                              <input
                                id="checkbox"
                                name="check1"
                                ref={register({ required: true })}
                                type="checkbox"
                                className="checkbox"
                              />
                              <label htmlFor="checkbox" className="checkbox">
                                「個人情報の取扱いに関する同意事項」と規約に同意する
                                <span className="requiredIcon">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col_12 con_form_box btn_box">
                      <button type="submit" className="btn">
                        注文内容の確認に進む
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default withRouter(FormInput);
